"use client";

import React from "react";
import Link from "next/link";
import styles from "./ContactCards.module.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
 
import Image from "next/image";

const ContactCards = () => {
  return (
    <div className="container">
      <div className="row g-4 g-lg-5 d-flex justify-content-center">

        {/* Call Us */}
        <div className="col-md-4">
          <div className={`${styles.cardBox} card rounded-4 p-4 h-100`}>
            <div>
              <div className={`${styles.iconLg} ${styles.bgSoftBlue} text-white rounded-circle mb-4`}>
                {/* <FontAwesomeIcon icon={faPhone} /> */}
                <Image src="/Call.svg" width={40} height={40} alt="..."/>
              </div>

              <h5 className={styles.title}>Call Us</h5>
              <p className={styles.text}>
                Speak directly with our support team — we’re always ready to help.
              </p>
            </div>

            <div className={`${styles.footer} pt-3`}>
              <Link href="tel:+17184146543" className={styles.primaryGrad}>
                +1 718 414 6543
              </Link>
            </div>
          </div>
        </div>

        {/* Mail Us */}
        <div className="col-md-4">
          <div className={`${styles.cardBox} card rounded-4 p-4 h-100`}>
            <div>
              <div className={`${styles.iconLg} ${styles.bgSoftGreen}  rounded-circle mb-4`}>
                {/* <FontAwesomeIcon icon={faEnvelope} /> */}
                <Image src="/Email.svg" width={40} height={40} alt="..."/>
              </div>

              <h5 className={styles.title}>Mail Us</h5>
              <p className={styles.text}>
              If you are existing Client , Please login to Client Portal and create a Ticket . For All Sales Queries , Please email us at.
              </p>
            </div>

            <div className={`${styles.footer} pt-3`}>
              <Link href="mailto:sales@temok.com" className={styles.primaryGrad}>
                sales@temok.com
              </Link>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ContactCards;
